<button fd-button [disabled]="disabled" [fdType]="'transparent'" id="personalize-button" (click)="openTablePersonalization()"
        i18n-title="XTOL|Tooltip of the table personalization button@@table-personalization.tooltips.button" title="Configure Table Columns">
    <app-icon [icon]="[$any('workspace'), $any('tableSettings')]" size="lg" [fixedWidth]="true"></app-icon>
</button>
